﻿import { apiPromise } from '../../../../Resources/Scripts/_Shared/fetch'
import { mockedData } from './MockedData'

export const permitService = {
  createPermits: async (data, mocked, lang) => mocked ? apiMockedPromise(`/landlord/createpermits`, data).catch((err) => err) : apiPromise(`/landlord/createpermits`, data, lang, 'POST').catch((err) => err),
  getPlaces: async (mocked) => mocked ? apiMockedPromise(`/landlord/getplaces`).catch((err) => err) : apiPromise(`/landlord/getplaces`).catch((err) => err),
  getTypes: async (data, mocked) => mocked ? apiMockedPromise(`/permits/types`).catch((err) => err) : apiPromise(`/permits/types`, data).catch((err) => err),
  getCustomers: async (mocked) => mocked ? apiMockedPromise(`/landlord/getcustomers`).catch((err) => err) : apiPromise(`/landlord/getcustomers`).catch((err) => err),
  getPermitDetails: async (data, mocked, lang) => mocked ? apiMockedPromise(`/permits/permitdetails`, data).catch((err) => err) : apiPromise(`/landlord/getpermitdetails`, data, lang).catch((err) => err),
  updatePermit: async (data, mocked, lang) => mocked ? apiMockedPromise(`/landlord/updatepermit`, data).catch((err) => err) : apiPromise(`/landlord/updatepermit`, data, lang, 'POST').catch((err) => err),
}

export const vehicles = {
  removeVehicle: async (data, mocked) => mocked ? apiMockedPromise(`/vehicle/deletevehicle`).catch((err) => err) : apiPromise(`/myaimoparksettingspage/deletevehicle`, data, 'POST').catch((err) => err),
  updateCustomerVehicle: async (data, mocked, lang) => mocked ? apiMockedPromise(`/booking/updatevehicle`).catch((err) => err) : apiPromise(`${data.bookingController}updatevehicle`, data.form, lang, 'POST').catch((err) => err),
  createCustomerVehicle: async (data, mocked, lang) => mocked ? apiMockedPromise(`/booking/createvehicle`).catch((err) => err) : apiPromise(`${data.bookingController}createvehicle`, data.form, lang, 'POST').catch((err) => err),
  getCustomerVehicles: async (data, mocked, lang) => mocked ? apiMockedPromise(`/booking/getvehicles`).catch((err) => err) : apiPromise(`${data.bookingController}getvehicles`, null, lang ).catch((err) => err),
  deleteVehicle: async (data, lang) => apiPromise(`/myaimoparksettingspage/deletevehicle`, data, lang, 'POST').catch((err) => err),
  checkPermitForDeleteVehicle: async (data) => apiPromise(`/myaimoparksettingspage/checkpermitfordeletevehicle`, data, 'POST').catch((err) => err),
}

export const users = {
  createUser: async (data, mocked, lang) => mocked ? apiMockedPromise(`/landlord/createuser`, data).catch((err) => err) : apiPromise(`/landlord/createuser`, data, lang, 'POST').catch((err) => err),
  deleteCustomer: async (data, mocked, lang) => mocked ? apiMockedPromise(`/user/removeuser`).catch((err) => err) : apiPromise(`/landlord/deletecustomer`, data, lang, 'POST').catch((err) => err),
  demoteAdmin: async (data, mocked, lang) => mocked ? apiMockedPromise(`/user/demoteadmin`).catch((err) => err) : apiPromise(`/landlord/demoteadmin`, data, lang, 'POST').catch((err) => err),
}

export const permits = {
  updatePermit: async (data, lang) => apiPromise(`/myaimopark/updatepermit`, data, lang, 'POST').catch((err) => err),
  approvePreliminaryOrder: async (data, lang) => apiPromise(`/myaimoparkpreliminaryorderpage/approvesalesorder`, data, lang, 'POST').catch((err) => err),
  declinePreliminaryOrder: async (data, lang) => apiPromise(`/myaimoparkpreliminaryorderpage/declinesalesorder`, data, lang, 'POST').catch((err) => err)
}

export const waitinglist = {
  registerForNotifications: async (data) => apiPromise('/waitinglist/RegisterForNotifications', data, null, 'POST').catch((err) => err),
  registerForWaitingList: async (data) => apiPromise('/waitinglist/RegisterForWaitingList', data, null, 'POST').catch((err) => err),
  getWaitingListItem: async (data) => apiPromise('/waitinglist/GetWaitinglistItem', data, null).catch((err) => err),
  removeFromWaitingList: async (data) => apiPromise('/waitinglist/RemoveFromWaitingList', data, null, 'DELETE').catch((err) => err),
  getNextAvailablePosition: async (data) => apiPromise('/waitinglist/GetNextAvailablePosition', data, null).catch((err) => err),
  uploadRequestAttachment: async (data, headers) => apiPromise('/waitinglist/UploadAttachment', data, null, 'POST').catch((err) => err),
  removeFromWaitingListApproval: async (data) => apiPromise('/waitinglist/RemoveFromWaitingListApproval', data, null, 'DELETE').catch((err) => err),
}

export const test = {
  getTestCall: async (data, returnTime = 3000) => {
    return new Promise((resolve) => {
      console.log(`Test call (${returnTime}ms). Data: `, data)

      setTimeout(() => {
        resolve({ status: 200, info: 'OK', body: 'Test call (3000ms)' });
      }, returnTime);
    });
  },
}

export const refreshlogin = async (mocked) => mocked ? apiMockedPromise(`/refreshlogin`).catch((err) => err) : apiPromise(`/refreshlogin`, null, 'POST').catch((err) => err)

const apiMockedPromise = (url, data = {}, returnTime = 0) => {
  return new Promise((resolve) => {
    let returnData;
    //let returnTime = 3000; //Milliseconds

    if(url.lastIndexOf('/landlord/getplaces', 0) === 0)
      returnData = mockedData.placesOptions;
    else if(url.lastIndexOf('/permits/types', 0) === 0)
      returnData = mockedData.permitTypeOptions;
    else if(url.lastIndexOf('/landlord/getcustomers', 0) === 0)
      returnData = mockedData.permitUserOptions;
    else if(url.lastIndexOf('/permits/permitdetails', 0) === 0)
      returnData = mockedData.permitDetails[data.permitId ?? 0], returnTime = 3000;
    else if(url.lastIndexOf('/vehicle/removevehicle', 0) === 0)
      returnData = '', returnTime = 500;
    else if(url.lastIndexOf('/user/removeuser', 0) === 0)
      returnData = '', returnTime = 500;
    else if(url.lastIndexOf('/landlord/createpermits', 0) === 0)
      returnData = data, returnTime = 1000;
    else if(url.lastIndexOf('/landlord/updatepermit', 0) === 0)
      returnData = data, returnTime = 1000;
    else if(url.lastIndexOf('/landlord/createuser', 0) === 0)
      returnData = data, returnTime = 500;
    else if (url.lastIndexOf('/refreshlogin', 0) === 0)
      returnData = data;
    else
      returnData = 'No mocked api endpoint match!'

    console.log(`Mocked data: ${url}, data: `, data, { status: 200, info: 'OK', body: returnData })

    setTimeout(() => {
      resolve({ status: 200, info: 'OK', body: returnData });
    }, returnTime === 0 ? (Math.floor(Math.random() * 5) * 1000) : returnTime);
  });
}